import Vue from 'vue'
import Vuex from 'vuex'
import Bus from '../utils/bus'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    dataName:["deviceTotal","deviceRate","deviceCallDay","deviceCallMonth","serverTotal","certTotal","sealTotal","keyTotal","runtimeDayTotal","runtimeMonthTotal","runtimeWeekTotal","warningLogs","certStatus","sealStatus","keyStatus","leaseholderRate","appRate"],
    WebSocketData: localStorage.getItem('WebSocketData') ? JSON.parse(localStorage.getItem('WebSocketData')) : {},
    comNav:[
      {
        name:'态势总览',
        comName:'componentIndex',
      },
      {
        name:'密码服务',
        comName:'component1',
      },
      {
        name:'密码资源',
        comName:'component2',
      },
      {
        name:'密钥管理',
        comName:'component3',
      },
      {
        name:'应用系统',
        comName:'component4',
      }
    ],
    comName:'componentIndex', // 当前组件名
  },
  mutations: {
    // 保存
    saveWebSocketData(state, WebSocketData) {
      state.WebSocketData = WebSocketData;
      localStorage.setItem('WebSocketData',JSON.stringify(WebSocketData))
    },
    // 保存
    changeComName(state, comName) {
      state.comName = comName;
    },
  },
  actions: {
  },
  modules: {
  }
})
